<template>
	<div>
		<a :href="href" :class="class" :target="target">
			<slot></slot>
		</a>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpButton',

	props: {
		type: {
			type: String,
			default: () => 'primary',
		},

		href: {
			type: String,
			default: () => '#',
		},

		target: {
			type: String,
			default: () => '_self',
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	computed: {
		class() {
			return `btn btn-${this.type}`;
		}
	}
}
</script>

<style scoped>
.btn {
	cursor: pointer;
	display: block;
	padding: 12px 32px 12px 32px;
	border-radius: 50px;
	background: #FFFFFF1A;

	text-decoration: none;
}

.btn-secondary {
	font-family: Poppins;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	text-align: left;
	color: #FFFFFF;
}

.btn-get-pro {
	background: linear-gradient(270deg, #F9AA39 0%, #FFDAA5 100%);
	font-family: Poppins;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-align: left;
	color: #231F20;
	padding: 12px 32px !important;
	display: block;
}
</style>